import moment from "moment";

export default {

    methods: {

		_googleTimeZone(lat, lng, data){

			let _data = new moment(data, $sessao.getDateFormat('HH:mm'))

			return new Promise((resolve) => {

				let url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${_data.unix()}&key=${this._googleKey}`;

                // return data
                this._httpGetExternal(url, (resposta) => {

                    if(resposta._request){
						resolve(resposta)
                    } else {
                        throw new Error("erro no request")
                    }
                })
            })
		},

        _httpGetExternal (url, callback, dataType){

			if(_.isNil(dataType)){
				dataType = 'json'
			}

            var rt = {
                data: "",
                request: false,
                erro: "",
			}

            jQuery.ajax({
                type: 'GET',
                url: url,
                dataType: dataType,
                success (retorno){
                    //console.log("retorno", retorno, url)
                    retorno._request = true
                    if(!_.isNil(retorno.status)){
                        if(retorno.status == 'sucesso'){
                            retorno._status = true
                        } else {
                            retorno._status = false
                        }
                    } else {
                        retorno._status = true
                    }

                    callback(retorno)
                },
                error (e) {
					console.log("ERRRRROO", e)
                    rt._request = false
                    rt.erro = e
                    //callback(rt)
                    //console.log(e);
                    bus.$emit('modal-erro-show',e);
                }
            });
        },


        _httpGet (url, callback, token){

            var rt = {
                data: "",
                request: false,
                erro: "",
			}

			let tk = ""

			if(_.isNil(token)){
				tk = this.getToken()
			} else {
				tk = token
			}

            jQuery.ajax({
                type: 'GET',
                headers: { 'Authorization': tk },
                url: this.getURL_WS(url),
                dataType: 'json',
                success: function (retorno){
                    //console.log("retorno", retorno, url)
                    retorno._request = true
                    if(!_.isNil(retorno.status)){
                        if(retorno.status == 'sucesso'){
                            retorno._status = true
                        } else {
                            retorno._status = false
                        }
                    } else {
                        retorno._status = true
                    }

                    callback(retorno)
                },
                error: function (e) {
					console.log("ERRRRROO", e)
                    rt._request = false
                    rt.erro = e
                    //callback(rt)
                    //console.log(e);
                    bus.$emit('modal-erro-show',e);
                }
            });
        },

        _httpPost (url, data, callback, token){

            var rt = {
                data: "",
                request: false,
                erro: "",
            }

            let tk = ""

			if(_.isNil(token)){
				tk = this.getToken()
			} else {
				tk = token
			}

            jQuery.ajax({
                type: 'POST',
                headers: { 'Authorization': tk },
                url: this.getURL_WS(url),
                data: { "data": JSON.stringify(data) },
                dataType: 'json',
                success: function (retorno){

                    retorno._request = true
                    if(retorno.status == 'sucesso'){
                        retorno._status = true
                    } else {
                        retorno._status = false
                    }

                    callback(retorno)
                },
                error: function (e) {
                    rt._request = false
                    rt.erro = e
                    //callback(rt)
                    //console.log(e);
                    bus.$emit('modal-erro-show',e);
                }
            });
		},

		_httpService (url, method, data, callback){

            var rt = {
                data: "",
                request: false,
                erro: "",
			}

			//console.log("key cliente", this._keyServices)

            jQuery.ajax({
                type: method,
                headers: { 'Authorization': this._keyServices },
				url: this.getURL_SERVICES(url),
				data: data != null ?  JSON.stringify(data) : null,
				contentType: 'application/json',
                success: function (retorno){
                    callback(retorno)
                },
                error: function (e) {
                    rt._request = false
                    rt.erro = e
                    // callback(rt)
                    console.log(e);
                    bus.$emit('modal-erro-show',e);
                }
            });
        },
    }
}